import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {FormDefinitionFieldModel} from "../../../api/entity/formDefinitionField.model";
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";

@Injectable()
export class FormDefinitionFieldRepository extends AbstractRepositoryV2<FormDefinitionFieldModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('FormDefinitionField', serviceElementsFactory, injector);
    }
}
